/**
 * Returns the WordPress-loaded version of Underscore for use with things that need it and use Require.
 *
 * @package LifterLMS/Scripts
 *
 * @since    3.16.0
 * @version  3.16.0
 */

define( 'jquery',[],function() {
	return jQuery;
} );

